export enum RenewalSchedule {
  TWO_MONTHS = "TWO_MONTHS",
  FOUR_MONTHS_LESS = "FOUR_MONTHS_LESS",
  FOUR_MONTHS_PLUS = "FOUR_MONTHS_PLUS",
}
